module.exports = __webpack_public_path__ + "img/全量同步.12999dc2.svg";